import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { navigateToRoute, logout } from "../actions/app.js";
import { moreVert, home, menu, logo, arrowRight, arrowLeft, error } from "../styles/icons.js";
import { getPdfReportPreview } from "../actions/pdf-utils.js";
import { completeCurrentInspection, getUpdateInspectionPromise, loadInspection, saveRemoteInspection, updateCurrentInspection } from "../actions/inspection.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { InspReportViewer } from "../elements/inspx-report-viewer.js";
import { InspxDialog } from "../elements/inspx-dialog.js";
import { validateCurrentInspection } from "../actions/validation.js";
import { computeParts, skippedTabs } from "../lib/helpers.js";
import { getSignatureDrawing } from "../data/images.js";
import { DrawingTool } from "./drawing/inspx-drawing-tool.js";

class InspxInspectionNavbar extends connect(store)(LitElement) {
	renderCommonCcss() {
		return html`
            ${SharedStyles}
            <style>
                .smaller {
                    font-size: smaller;
                }

                .invalid-mark {
                    align-self: start;
                }

				.invalid-mark svg {
                    fill: #ff6666;
                    width: 15px;
                    height: 15px;
				}
            </style>`;
	}

	renderDrawerCss() {
		return html`
            <style>
                :host {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    background-color: var(--primary-color);
                    cursor: pointer;
                    justify-content: space-between;
                }
                
                .drawer-logo{
                    width: 100%;
                    background-color: var(--secondary-color);
                    height: 80px;
                    padding: 13px;
                    box-sizing: border-box;
                    box-shadow: 0px 1px 2px #464646;
                }

                .menu {
                    fill: white;
                    padding: 20px;
                    cursor: pointer;
                    align-self: flex-end;
                }

                .drawer {
                    position: fixed;
                    left: -200px;
                    background-color: var(--primary-color);
                    top: 0px;
                    height: 100vh;
                    width: 0px;
                    color: white;
                    transition: left 0.2s;
                    z-index: 100;
                    overflow-y: scroll;
                    fill: white;
                    box-shadow: 3px 0 4px -2px #7b7b7b;
                    overflow: hidden;
					width: 200px;
                }

				.drawer.open {
                    left: 0px;
                    overflow-y: auto;
                }

                .tab-label-content {
                    padding: 15px;
                    text-transform: uppercase;
                }

                .icon-button {
                    padding: 15px;
                    cursor: pointer;
                }

                label:hover,
                .icon-button:hover {
                    background-color: var(--secondary-color);
                    cursor: pointer;
                }

                input[type="radio"][name="tabs"][checked]+ label {
                    background-color: var(--primary-color-variant3);
                    border-bottom: 2px solid var(--secondary-color);
                    color: var(--secondary-color);
                }

                a {
                    color: white;
                    text-decoration: none;
                    display: block;
                    padding: 8px 16px;
                }

                input[type="radio"][name="tabs"] {
                    display: none;
                }

                .separator {
                    height: 1px;
                    background-color: white;
                    width: 100%;
                }

                .logo {
                    font-size: smaller;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: flex-end;
                    padding-right: 25px;
                }

                .inspx {
                    font-size: large;
                }
              
                .headerAndTabTitle{
                  flex-direction: column;
                  display: flex;                 
                  text-align: center;
                  justify-content: space-evenly;
                  align-items: center;
                }

                .drawer-logo svg{
                    height: 53px;
                }

                label {
                    display: inline-flex;
                    width: 100%;
                    justify-content: space-between;
                }

                .report-is-generating .icon-button[report],
                .report-is-generating .icon-button[report]:hover {
                    background-color: var(--primary-color);
                    color: lightgray;
                    cursor: not-allowed;
                }
            </style>`;
	}

	renderTabsCss() {
		return html`
            <style>
                input[type="radio"][name="tabs"]+label {
                    border-bottom: 3px solid transparent;
                }

                input[type="radio"][name="tabs"][checked]+label {
                    /* background-color: var(--primary-color-variant1); */
                    border-bottom: 3px solid var(--secondary-color);
                }

                .tabs {
                    display: flex;
                    background-color: var(--primary-color);
                    cursor: pointer;
                    padding: 0 5px;
                }

                .tab-wrap {
                    position: relative;
                    display: flex;
                    width: calc(100vw - 114px);
                    overflow-y: scroll;
                    margin: 0 5px;
                }
                
                ::-webkit-scrollbar {
                    height: 0;
                    width: 0px;
                    background: transparent; 
                }

                input[type="radio"][name="tabs"] {
                    position: absolute;
                    z-index: -1;
                    visibility: hidden;
                }

                input[type="radio"][name="tabs"][checked]+.tab-label-content label {
                    color: white;
                }

                input[type="radio"][name="tabs"][checked]+.tab-label-content .tab-content {
                    display: block;
                }

                label {
                    cursor: pointer;
                    color: rgba(255, 255, 255, 0.8);
                    text-transform: uppercase;
                    box-sizing: border-box;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    height: 56px;
                    padding: 0 10px;
                    transition: color 0.2s ease;
                    width: 100%;
                }

                .tab-label-content {
                    width: 100%;
                    padding: 0 5px;
                    white-space: nowrap;
                }

                .tab-label-content .tab-content {
                    position: absolute;
                    top: 100px;
                    left: 16px;
                    line-height: 130%;
                    display: none;
                }

                .follow {
                    width: 42px;
                    height: 42px;
                    border-radius: 50px;
                    background: #03A9F4;
                    display: block;
                    margin: 300px auto 0;
                    white-space: nowrap;
                    padding: 13px;
                    box-sizing: border-box;
                    color: white;
                    transition: all 0.2s ease;
                    font-family: Roboto, sans-serif;
                    text-decoration: none;
                    box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.2);
                }

                .follow i {
                    margin-right: 20px;
                    transition: margin-right 0.2s ease;
                }

                .follow:hover {
                    width: 134px;
                }

                .follow:hover i {
                    margin-right: 10px;
                }

                .icon-button,
                .nav-arrow {
                    fill: white;
                    align-self: center;
                    padding: 5px;
                    cursor: pointer;
                }
            
                .nav-arrow {
                    width: 30px;
                }

                @media screen and (max-width: 800px) {
                    .follow {
                        margin: 400px auto 0;
                    }
                }

                .header-caption {
                    padding: 0 10px;
                    display: flex;
                    justify-content: space-between;
                    background-color: var(--secondary-color);
                }

                .small-caption {
                    font-size: 10px;
                    align-self: center;
                }

                .more-button {
                    position: relative;
                    cursor: pointer;
                }

                .more-button a {
                    outline: none;
                    text-decoration: none;
                    color: rgba(255, 255, 255, 0.8);
                    display: block;
                }

                .more-button ul {
                    z-index: 1000;
                    background: black;
                    cursor: pointer;
                    box-shadow: 0px 1px 1px #464646;
                    border-radius: 3px;
                    visibility: hidden;
                    opacity: 0;
                    min-width: 15rem;
                    position: absolute;
                    transition: all 0.5s ease;
                    right: 0;
                    display: none;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    margin-top: -4px;
                    margin-right: 5px;
                }

                .more-button:hover > ul,
                .more-button ul:hover {
                    visibility: visible;
                    opacity: 1;
                    display: block;
                }

                .more-button ul li {
                    clear: both;
                    width: 100%;
                    cursor: pointer;
                }

                .more-button ul li a {
                    padding: 10px 20px;
                }

				.more-button ul li:hover {
					background-color: var(--secondary-color);
				}

                .report-is-generating .more-button .dropdown li[report],
                .report-is-generating .more-button .dropdown li[report] a, 
                .report-is-generating .more-button .dropdown li[report]:hover
                .report-is-generating .more-button .dropdown li[report] a:hover {
                    background-color: black;
                    color: darkgray;
                    cursor: not-allowed;
                }
            </style>`;
	}

	shouldUpdate(changedProps) {
		if (window.innerWidth != this._lastWidth) {
			this._shouldAutoScroll = true;
			return true;
		}

		if (this.items != undefined) {
			if (
				changedProps &&
                changedProps.items != undefined &&
                this.items != undefined
			) {
				return (
					JSON.stringify(changedProps.items) != JSON.stringify(this.items) ||
                    changedProps.selectedValue != this.selectedValue ||
                    this.drawerOpen != changedProps.drawerOpen
				);
			}

			return true;
		}
		return false;
	}

	isMobileView() {
		return window.innerWidth < 801; // <= 700
	}

	static get properties() {
		return {
			items: { type: Array },
			selectedValue: { type: String },
			online: { type: Boolean },
			username: { type: String },
			headerTitle: { type: String },
			drawerOpen: { type: Boolean },
			isBackwardVisible: { type: Boolean },
			isForwardVisible: { type: Boolean },
			validation: { type: Object },
			_isReportGenerating: { type: Boolean },
			swVersion: { type: String },
		};
	}

	render() {
		this._lastWidth = window.innerWidth;
		return this.isMobileView() ? this._renderMobile() : this._renderDesktop();
	}
    
	_renderMobile() {
		const drawerClass = "drawer" +
            (this.drawerOpen ? " open" : "") +
            (this._isReportGenerating ? " report-is-generating" : "");
		const index = this.items.map(i => i.val).indexOf(this.selectedValue);
		const selectedText = index === -1 ? '' : this.items[index].text;
		return html`
            ${this.renderCommonCcss()} 
            ${this.renderDrawerCss()}
            <div class="menu" @click="${() => { this.drawerOpen = !this.drawerOpen; }}">
                ${menu}
            </div>
            <div class="${drawerClass}">
                <div class="drawer-logo">${logo}</div>
                ${this.renderHomeButton()}
                <div class="separator"></div>
                ${this.items.map((item, idx) => this.renderItem(item, idx))}
                <div class="separator"></div>
                ${this.renderMoreButton()}
            </div>
            <div class="headerAndTabTitle">
                <div class="header-title">${this.headerTitle}</div>
                <div class="tab-title">
                    ${selectedText}
                    ${this.renderInvalidMark(this.selectedValue)}
                </div>
            </div>
            <div class="logo">
                <div class="inspx">
					<span>InspX</span>
                    <span class="smaller"> - ${this.username}</span>
                </div>
                <div>${this.online ? "ON-LINE" : "OFF-LINE"}</div>
            
            </div>`;
	}
    
	_renderDesktop() {
		const tabsClass = "tabs" +
            (this._isReportGenerating ? " report-is-generating" : "");
		return html`
            ${this.renderCommonCcss()} ${this.renderTabsCss(this.items)}		
            <div class="header-caption">
                <div>
                    <span>InspX</span>
                    <span class="smaller"> - ${this.username}</span>
                </div>
                <div>${this.headerTitle}</div>
                <div class="small-caption">${this.online ? "ON-LINE" : "OFF-LINE"}
                </div>
            </div>
            <div class="${tabsClass}">
                ${this.renderHomeButton()}
                <div class="nav-arrow" @click="${() => { this._tabBackward() }}">
                    ${this.isBackwardVisible ? arrowLeft : ''}
                </div>
                <div class="tab-wrap"
                    @scroll="${(e) => this._tabWrapScrollHandler(e)}"
                    @touchmove="${(e) => e.preventDefault()}">
                    ${this.items.map((item, idx) => this.renderItem(item, idx))}
                </div>
                <div class="nav-arrow" @click="${() => { this._tabForward() }}">
                    ${this.isForwardVisible ? arrowRight : ''}
                </div>
                ${this.renderMoreButton()}
            </div>`;
	}

	renderHomeButton() {
		if (!this.isInspectionContext()) { return; }

		return html`
            <div class="icon-button" @click="${() => this._homeButtonClick()}">
                ${this.isMobileView() ? 'HOME' : home}
            </div>`;
	}

	renderMoreButton() {
		const buttons = [];
		if (this.isInspectionContext()) {

			const repButtons = this._getReportButtons();
			if (Array.isArray(repButtons)) {
				repButtons.forEach((b) => {
					buttons.push(b);
				});
			} else {
				buttons.push(repButtons);
			}

			if (!this.isRemote) {
				buttons.push({
					l: "Complete",
					c: e => this._openCompleteConfigmation(e)
				});
				buttons.push({
					l: "Cancel",
					c: e => this._openCancelConfigmation(e)
				});
			} else if(INSP.APP.openedFromCore )
				buttons.push({
					l: "Save correction",
					c: e => this._openCompleteConfigmation(e,true)
				});
		}

		buttons.push({
			l: "Logout",
			c: e => this._logout(e)
		});

		if (this.isMobileView()) {
			return buttons.map(b => html`<div class="icon-button" ?report="${b.r}" @click="${b.c}">${b.l}</div>`);
		}

		return html`
            <div class="icon-button more-button">
                ${moreVert}
                <ul class="dropdown">
                    ${buttons.map(b => html`<li ?report="${b.r}"><a href="#" @click="${b.c}">${b.l}</a></li>`)}
                </ul>
            </div>`;
	}

	_getReportButtons() {
		if (this.inspection.type.reports != undefined && this.inspection.type.reports.length > 0) {
			return this.inspection.type.reports.map((r) => {
				return {
					r: true,
					l: r.name,
					c: e => this._previewPdf(e, r.name)
				};
			});
		}

		return {
			r: true,
			l: "Default Report",
			c: e => this._previewPdf(e)
		};
	}

	renderItem(i, idx) {
		const checked = this.selectedValue === i.val;
		return html`
            <input type="radio" name="tabs" id="tab${idx}"
                ?checked="${checked}" 
                .checked="${checked}"
                .value="${i.val}"
                @change="${e => this.handleChangeEvent(e)}"
                @click="${e => this.handleClickEvent(e)}">
			<label for="tab${idx}">
				<div class="tab-label-content" id="tab${idx}-content">
					${i.text}				
                </div>
                ${this.renderInvalidMark(i.val)}
			</label>`;
	}

	renderInvalidMark(tabName) {
		const invalid = (this.validation.invalidTabs.indexOf(tabName) > -1);
		if (invalid) {
			return html`<span class="invalid-mark" title="The tab has invalid data">${error}</span>`;
		}
		return;
	}

	_checkVisibility() {
		if (this.isMobileView()) return;

		const wrap = this.shadowRoot.querySelector('.tab-wrap');
		let totalWidth = 0;
		for (const child of wrap.children) {
			if (child.localName === 'label') {
				totalWidth += child.clientWidth;
			}
		}
		if (wrap.clientWidth < totalWidth) {
			this.isBackwardVisible = wrap.scrollLeft !== 0
			this.isForwardVisible = ((wrap.offsetWidth + wrap.scrollLeft) !== wrap.scrollWidth)
		} else {
			this.isBackwardVisible = this.isForwardVisible = false
		}
	}
    
	_scrollNavTo(offset) {
		const wrap = this.shadowRoot.querySelector('.tab-wrap');
		offset = wrap.scrollLeft + offset;
        
		let x = wrap.scrollLeft, dx, end = false;
		const call = setInterval(() => {
			if (Math.abs(dx = offset - x) > 1) {
				x += dx / 8;
			} else {
				clearInterval(call);
				x = offset;
				end = true;
			}
			wrap.scrollLeft = x < 0 ? 0 : x;
			if (end) {
				this._checkVisibility();
			}
		}, 8);
	}

	_tabForward() {
		if (this.isMobileView()) return;
		this._scrollNavTo(200);
	}

	_tabBackward() {
		if (this.isMobileView()) return;
		this._scrollNavTo(-200);
	}
    
	_scrollIntoViewByIndex(index) {
		if (this.isMobileView()) return;
		const idx = this.items.findIndex(i => i.val === index);
		const div = this.shadowRoot.querySelector(`#tab${idx}-content`);
		if (!div) return;
		const element = div.parentElement;
		if (!element) return;

		const wrap = this.shadowRoot.querySelector('.tab-wrap');
		if (wrap.scrollLeft > element.offsetLeft) {
			this._scrollNavTo(element.offsetLeft - wrap.scrollLeft - 10);
			return true;
		} else {
			let sumWidth = 0;
			for (const child of wrap.children) {
				if (child.localName === 'label') {
					sumWidth += child.clientWidth;
					if (child === element) {
						let b = 9;
						break;
					}
				}
			}
			if (sumWidth > wrap.clientWidth + wrap.scrollLeft) {
				this._scrollNavTo(sumWidth - (wrap.clientWidth + wrap.scrollLeft));
				return true;
			}
		}
		this._checkVisibility();
		return true;
	}

	_homeButtonClick() {
		this._navigateToRoute({
			page: "active-inspections",
			subpage: null,
			id: null
		});
		this.drawerOpen = false;
	}

	async __processMenuClick(e) {
		if (e) {
			e.preventDefault();
		}
		this.drawerOpen = false;
		await getUpdateInspectionPromise();
	}

	_logout(e) {
		this.__processMenuClick(e);
		store.dispatch(logout());
	}

	_generateReportByName(inspId, reportName) {
		this._isReportGenerating = true;
		store.dispatch(getPdfReportPreview(inspId, reportName))
			.then((dataUrl) => {
				const viewer = new InspReportViewer(dataUrl, this.id, reportName);
				document.body.appendChild(viewer);
			})
			.finally(() => this._isReportGenerating = false);
	}

	_previewPdf(e, reportName) {
		this.__processMenuClick(e);
		if (!this.id || this._isReportGenerating) return;

		if (!this.inspection.type.reports || !this.inspection.type.reports.length) {
			this._generateReportByName(this.id, reportName);
			return;
		}
		const report = this.inspection.type.reports.find(r => r.name === reportName);
		if (report) {
			const validate = report.validateBeforeReport;
			const askForSignature = report.askForSignature;
			if (validate) {
				store.dispatch(validateCurrentInspection()).then(() => {
					if (!this.validation.isInspectionValid) {
						this._openValidationErrorsDialog();
					} else {
						this._checkForSignature(askForSignature, reportName);
					}
				});
			} else {
				this._checkForSignature(askForSignature, reportName);
			}
			return;
		}
		this._generateReportByName(this.id, reportName);
	}
    
	_checkForSignature(askForSignature, reportName) {
		if (!askForSignature) {
			this._generateReportByName(this.id, reportName);
			return;
		}
        
		getSignatureDrawing(this.id).then(sign => {
			if (sign == undefined && !this.isRemote) {
				this._openAskForSignatureDialog(reportName);
			} else {
				this._generateReportByName(this.id, reportName);
			}
		});
	}

	_openCancelConfigmation(e) {
		this.__processMenuClick(e);
		let dialog = new InspxDialog();
		dialog.cancellable = true;
		dialog.headerLabel = 'Inspection Canceling Confirmation';
		dialog.content = 'You`re about to cancel inspection. It means that all required fields will be filled with empty space. Are you sure you want to proceed? ';
		dialog.addEventListener('dialog-accept', (e) => {
			this._cancelInsp();
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', (e) => {
			dialog.remove();
		});
		document.body.appendChild(dialog);
		dialog.open();
	}

	_cancelInsp() {
		if (this.id) {
			store.dispatch(updateCurrentInspection({ action: { name: "cancelInspection" } })).then(() => {
				location.reload();
			});
		}
	}
    
	_openCompleteConfigmation(e, corr) {
		this.__processMenuClick(e);
        
		let dialog = new InspxDialog();
		dialog.cancellable = true;
        dialog.headerLabel = 'Inspection Completing Confirmation';
		dialog.content = 'Are you sure you want to complete the inspection?';
		if(corr){
			dialog.content = 'Are you sure you want to save correction?';
		}
		dialog.addEventListener('dialog-accept', (e) => {
			if(corr){
				this._saveCorrection();
			}else
				this._completeInsp();
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', (e) => {
			dialog.remove();
		});
		document.body.appendChild(dialog);
		dialog.open();
	}

	_completeInsp() {
		if (this.id && !this.id.startsWith('copy_')) {
			store.dispatch(completeCurrentInspection()).then(() => {
				if (!this.validation.isInspectionValid) {
					this._openValidationErrorsDialog();
				} else if (!this.validation.relatedInspectionsCheck) {
					this._openRelatedInspectionsDialog();
				}
			});
		}
	}
    
	_saveCorrection() {
		if (this.id) {
			store.dispatch(saveRemoteInspection()).then(() => {
				if (!this.validation.isInspectionValid) {
					this._openValidationErrorsDialog();
				}
			});
		}
	}

	_openValidationErrorsDialog() {
		const dialog = new InspxDialog();
		dialog.headerLabel = "InspX Validation"
		dialog.cancellable = false;
		dialog.acceptLabel = "Ok";
		dialog.addEventListener('dialog-accept', () => {
			dialog.remove();
		});

		const renderError = (e) => html`
			<tr>
				<td>${e.fullPath}</td>
				<td>${e.error.origError.message}</td>
			</tr>
		`;

		dialog.content = html`
			<style>
				.dialog-content h4 {
					margin: 0;
					padding: 0;
				}
				.dialog-content table {
					table-layout: fixed;
				}
				.dialog-content table thead {
					text-align: left;
				}
				.dialog-content table td {
					padding: 2.5px 1px;
					word-break: break-word;
				}
				.dialog-content table td:first-child {
					width: 40%;
				}
				.dialog-content hr {
					border: 0;
					height: 1px;
					background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0));
				}
				.dialog-content p {
					margin-top: 5px;
				}
			</style>
			<div class="dialog-content">
				<h4>The list of found errors:</h4>
				<table>
					<thead><th>Path</th><th>Error Message</th></thead>
					<tbody>
						${this.validation.invalidFields.map(e => renderError(e))}
					</tbody>
				</table>
				<hr>
				<p>Please fix all the errors before the completion of the inspection.</p>
			</div>`;

		document.body.appendChild(dialog);
		dialog.open();
	}

	_openRelatedInspectionsDialog() {
		const dialog = new InspxDialog();
		dialog.headerLabel = "Onafgeronde inspecties gevonden";
		dialog.cancellable = true;
		dialog.acceptLabel = "OK, toch afronden";
		dialog.cancelLabel = "Annuleer";
		dialog.addEventListener('dialog-accept', () => {
			store.dispatch(completeCurrentInspection(true))
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', () => {
			dialog.remove();
		});
		dialog.content = html`<span style="color: #d5212e; font-weight: bolder;">Let op!</span> Er zijn inspecties binnen hetzelfde project die nog niet zijn afgerond. Deze dienen eerst afgerond te worden. De huidige inspectie dient als laatste afgerond te worden.`;
		this.shadowRoot.appendChild(dialog);
		dialog.open();
	}
    
	_openAskForSignatureDialog(reportName) {
		const dialog = new InspxDialog();
		dialog.headerLabel = "InspX Asking For Signature"
		dialog.cancellable = true;
		dialog.acceptLabel = "Add Signature";
		dialog.cancelLabel = "Skip";
		dialog.addEventListener('dialog-accept', () => {
			this._openDrawingSignature(reportName);
			dialog.remove();
		});
		dialog.addEventListener('dialog-cancel', () => {
			this._generateReportByName(this.id, reportName);
			dialog.remove();
		});
		dialog.content = 'Do you want to add the DTA signature to the report?';
		document.body.appendChild(dialog);
		dialog.open();
	}
    
	_openDrawingSignature(reportName) {
		let dt = new DrawingTool(true);
		dt.addEventListener('onDrawingToolClosed', () => this._generateReportByName(this.id, reportName));
		document.body.appendChild(dt);
	}

	_navigateToRoute(r) {
		store.dispatch(navigateToRoute(r));
	}
    
	_tabWrapScrollHandler(e) {
		if (!this._isScrolling) {
			this._isScrolling = true;
			window.requestAnimationFrame(() => {
				this._checkVisibility();
				this._isScrolling = false;
			});
		}
	}

	handleChangeEvent(e) {
		this._scrollIntoViewByIndex(e.currentTarget.value);
		window.INSP.restoreScroll = undefined;
		if (this.isInspectionContext()) {
			this._navigateToRoute({ subpage: e.currentTarget.value });
		} else {
			this._navigateToRoute({ page: e.currentTarget.value });
		}
		this.drawerOpen = false;
	}
    
	handleClickEvent(e) {
		this._scrollIntoViewByIndex(e.currentTarget.value);
	}

	get selected() {
		var c = this.shadowRoot.querySelector('input[type="radio"][checked]');
		if (c) {
			return c.value;
		} else {
			return this.items[0].val;
		}
	}

	constructor() {
		super();
        
		this.addEventListener("click", e => {
			e.stopPropagation();
		});
		this.__windowResizeEventHandler = () => {
			this.requestUpdate();
		};
		this.__windowClickEventHandler = () => {
			this.drawerOpen = false;
		};
		this._shouldAutoScroll = true;
		this._isReportGenerating = false;
	}
    
	connectedCallback() {
		super.connectedCallback();
		window.addEventListener('resize', this.__windowResizeEventHandler);
		window.addEventListener('click', this.__windowClickEventHandler);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		window.removeEventListener('resize', this.__windowResizeEventHandler);
		window.removeEventListener('click', this.__windowClickEventHandler);
	}

	isInspectionContext() {
		return (
			this.inspection != undefined &&
            Object.getOwnPropertyNames(this.inspection).length > 0
		);
	}

	stateChanged(state) {

		this.isRemote = state.inspection.remote != null;

		this.inspection = state.inspection.current || (this.isRemote ? state.inspection.remote.inspection : undefined);
		if (this.isInspectionContext()) {
			this.items = this.getFields(this.inspection.type.schema);

			if (this.isRemote && !state.app.route.subpage) {
				store.dispatch(navigateToRoute({ subpage: this.items[0].val }))
			}

			this.selectedValue = state.app.route.subpage;
			this.id = state.app.route.id;
		} else {
			this.items = [
				{ val: "new-inspections", text: "Nieuw" },
				{ val: "active-inspections", text: "Bezig" },
				{ val: "completed-inspections", text: "Klaar" }
			];
			this.selectedValue = state.app.route.page;
		}
		this.online = state.app.online;
		this.username = state.app.username;
		this.validation = state.validation;
	}

	updated() {
		if (this._shouldAutoScroll) {
			const result = this._scrollIntoViewByIndex(this.selectedValue);
			if (result) {
				this._shouldAutoScroll = false;    
			}
		}
	}

	getFields(s) {
		let fields = [];
		if (s != undefined) {
			const parts = computeParts(s);

			fields = parts
				.filter((p) => skippedTabs.indexOf(p.name) === -1)
				.map((p) => ({ val: p.name, text: s.properties[p.name].title }));

			fields.push({
				val: "images",
				text: "AFBEELDINGEN"
			});
			fields.push({
				val: "drawings",
				text: "TEKENINGEN"
			});
		}
		return fields;
	}
}

window.customElements.define("inspx-inspection-navbar", InspxInspectionNavbar);
